/** Largeur max éditeur flux (formulaires wizard) — alignée sur `$waste-flow-layout-width` (SCSS) */
export const WASTE_FLOW_LAYOUT_WIDTH_PX = 1250;

export const TAB_IDS = {
  general: "general",
  costs: "costs",
  proUnauthorized: "proUnauthorized",
  hwUnauthorized: "hwUnauthorized",
  modifications: "modifications",
};

export const DEFAULT_WASTE_FORM = {
  hazardous: false,
  value: "",
  label: "",
  unCodeFull: "",
  unCodeEmpty: "",
  wasteCodeFull: "",
  wasteCodeEmpty: "",
  transportCost: 0,
  treatmentCostFull: 0,
  treatmentCostEmpty: 0,
  treatmentCostUnit: "ton",
  density: "",
  displayColor: "#FF0000",
  isValorizationEligible: false,
  authorizedMaterial: [],
  compactionFactor: 1,
  active: true,
};

/** État initial création wizard (champs vides pour placeholders maquette) */
export const DEFAULT_WASTE_CREATE_FORM = {
  ...DEFAULT_WASTE_FORM,
  displayColor: "",
  treatmentCostUnit: "ton",
  treatmentCostFull: "",
};
